const closeWindow = function () {
  if (!(window as any).raw) {
    alert('请在盒子中打开');
    return;
  }
  (window as any).raw.controlWindow({ operation: 'hide', target: 'login' }, (e: any) => {
    console.log(e);
  });
};
const quitBox = function () {
  if (!(window as any).raw) {
    alert('请在盒子中打开');
    return;
  }
  if ((window as any).raw.quitBox) {
    localStorage.removeItem('TEMPDOMAIN');
    localStorage.removeItem('LOCALDOMAIN');
    (window as any).raw.quitBox({}, (e: any) => {
      console.log(e);
    });
  }
  (window as any).raw.controlWindow({ operation: 'hide', target: 'login' }, (e: any) => {
    console.log(e);
  });
};
const openMain = function () {
  (window as any).raw.loginWindow({}, (e: any) => {
    console.log(e);
  });
};
const utils = {
  closeWindow,
  openMain,
  quitBox
};

export default utils;
